/* This file is autogenerated, see readme.md for instructions */
import SearchSvgIcon from '@bloomreach/banana-theme/icons/search.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SearchIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SearchSvgIcon />
    </Icon>
  );
});

SearchIcon.displayName = 'SearchIcon';

export default SearchIcon;
